export default "__VITE_ASSET__d26cd485__"